import Cart_Compo from "../features/Cart/Cart_Compo";

function CartPage() {
    return (
        <Cart_Compo />
    );
}

export default CartPage;